<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-card-title class="toolbar primary white--text">
          <v-icon dark>
            note_add
          </v-icon>
          <h3
            class="title ml-2"
          >
            Show Account History
          </h3>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            X
          </v-btn>
        </v-card-title>
        <v-progress-linear
          v-if="isLoading"
          :indeterminate="true"
          class="ma-0"
        />
        <v-data-table
          :headers="headers"
          :items="history"
          :pagination.sync="pagination"
          :loading="isLoading"
          loading-text="Loading..."
          disable-initial-sort
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr>
              <td class="">
                {{ props.item.id }}
              </td>

              <td class="">
                {{ props.item.status }}
              </td>
              <td class="text-xs">
                {{ (new Date(props.item.timestamp)).toISOString() }}
              </td>

              <td>
                {{ props.item }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'ShowAccountHistory',

  props: {
    strategyId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    selectedUser: null,
    isOpenProp: this.isOpen,
    isLoading: false,
    history: [],
    pagination: {
      rowsPerPage: -1,
    },
    search: '',
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Status', value: 'status' },
      { text: 'Updated At', value: 'timestamp' },
      { text: 'Data', value: 'Data' },
    ],
  }),
  async mounted() {
    await this.$store.dispatch('fetchStrategyHistory', this.strategyId);
    this.history = this.$store.state.strategiesStore.strategyHistory;
  },
  methods: {
    onToggleOpen() {
      this.toggleOpen();
    },
  },
};
</script>

<style lang="scss">
  .create-bridge-signing {
    .v-card__title {
      padding: 24px;
    }

    .v-card__text {
      max-height: 65vh;
      overflow: auto;
      padding-top: 32px;
    }

    .v-card__actions {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
    }

    .radio-label {
      position: absolute;
      font-size: 16px;
      text-align: left;
      max-width: 133%;
      height: 20px;
      left: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.54);
      -webkit-transform: translateY(-18px) scale(0.75);
      transform: translateY(0px) translateX(-6px) scale(0.75);
    }

    .subheading {
      padding: 8px;
      background: white;
      color: rgba(0, 0, 0, 0.54);
      top: -20px;
      left: 8px;
      position: absolute;
      display: flex;
      align-items: center;
    }

    .form-group {
      padding: 16px;
      margin: 0 0 24px 0;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 5px;
      position: relative;
    }

    .container.grid-list-md .layout:not(:only-child) {
      margin: 0 0 24px 0;
    }

    .v-input--selection-controls.v-input .v-label {
      text-transform: capitalize;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/digitalDepots/dialog/account/ShowAccountHistory.vue